import { defineComponent as _defineComponent } from 'vue'
import { ref } from 'vue';
import type { SelectOption, OrganizationFormData } from '../types';
import IconEmail from '@/components/icons/IconEmail.vue';
import IconProfile from '@/components/icons/IconProfile.vue';
import IconPhone from '@/components/icons/IconPhone.vue';
import IconHome from '@/components/icons/IconHome.vue';
import IconBriefcase from '@/components/icons/IconBriefcase.vue';
import IconGlobal from '@/components/icons/IconGlobal.vue';

type FormData = Omit<OrganizationFormData, 'coupon' | 'plan_id'>


export default /*#__PURE__*/_defineComponent({
  __name: 'CompanyRegisterForm',
  props: {
    industries: { default: () => [] },
    countries: { default: () => [] }
  },
  setup(__props: any) {





const formData = ref<Partial<FormData>>({
    name: undefined,
    phone: undefined,
    email: undefined,
    website: undefined,
    country: undefined,
    industry: undefined,
});

const phoneValid = ref<boolean>(false);
const phoneValidationRules = { phoneValidation: ({ value }: { value: string }) => value?.length && phoneValid.value };
const phoneValidationMessages = { phoneValidation: () => 'Please enter a valid phone number' };

function handleValidatePhone({ valid }: { valid: boolean }) {
    phoneValid.value = valid;
}

function handleWebsiteBlur() {
    if (formData.value.website && !formData.value.website.startsWith('http')) {
        formData.value.website = `https://${formData.value.website}`;
    }
}

const OpenIndicator = ref({
    render: (createElement: any) =>
        createElement('span', { class: { toggle: true } }),
});

return { __sfc: true,formData, phoneValid, phoneValidationRules, phoneValidationMessages, handleValidatePhone, handleWebsiteBlur, OpenIndicator, IconEmail, IconProfile, IconPhone, IconHome, IconBriefcase, IconGlobal }
}

})